var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLink)?_c('p',{staticClass:"news-category",class:'is-'+_vm.categoryId},[_vm._v(_vm._s(_vm.categories[_vm.categoryId]))]):_c('p',{staticClass:"news-category",class:'is-'+_vm.categoryId},[_c('router-link',{attrs:{"to":{
      name: 'NewsCategoryList',
      params: {
        category: _vm.categoryId,
      },
    }}},[_vm._v(_vm._s(_vm.categories[_vm.categoryId]))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }